// Pure helpers for the Knowledge Repository view. The data itself is derived by
// the server from the operational records (there is nothing to resolve or copy
// here); this only holds display conversions. No React/I/O,
// so it is unit-tested.
import { DISTRIBUTION_METHOD_LABEL, RESPONSE_RATING_LABEL } from "../../constants/tspOperations";

export const methodLabel = (method) => (method ? DISTRIBUTION_METHOD_LABEL[method] || method : "—");
export const responseLabel = (rating) => (rating ? RESPONSE_RATING_LABEL[rating] || rating : "—");

// A stable colour per row for the by-book / by-method charts (presentation only).
const PALETTE = ["#E07B1A", "#D99A28", "#38BDF8", "#10B981", "#8B5CF6", "#E879A8", "#14B8A6", "#4F46E5", "#F43F5E"];
export const paletteColor = (index) => PALETTE[index % PALETTE.length];

// The by-method donut's rows: label, books, percent text and colour.
export function methodChartData(byMethod) {
  return byMethod.map((row, index) => ({ name: methodLabel(row.method), value: row.quantity, percent: `${row.percent}%`, color: paletteColor(index) }));
}

// Scale for the by-book bars: every bar is drawn relative to the largest.
export function barPercent(value, rows) {
  const max = Math.max(...rows.map((row) => row.quantity), 0);
  return max === 0 ? 0 : (value / max) * 100;
}

// The distinct teams named on a city's visit history (only those the caller may see).
export const teamsOf = (visits) => [...new Set((visits || []).map((visit) => visit.team?.name).filter(Boolean))];
